import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "tableIsShow", true);
        Vue.set(state, "formIsShow", false);
    },
    showTable(state) {
        state.tableIsShow = true;
        state.formIsShow = false;
    },
    showForm(state) {
        state.tableIsShow = false;
        state.formIsShow = true;
    }
}
